module.exports = __webpack_public_path__ + "img/spgl1.b1170650.png";